import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface PrioritizeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PrioritizeDialog: React.FC<PrioritizeDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: '600' }}>
        Prioritize Lead's evaluation
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Typography>
          Are you sure you want to prioritize the lead's evaluation?
        </Typography>
        <Typography>
          The selected leads will be given priority to be evaluated / scored first.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          sx={{
            background: '#FAFAFA',
            border: '1px solid #D1D5DB',
            color: '#111827',
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          sx={{ border: '1px solid #111827', background: '#325CD6' }}
          variant="contained"
          onClick={onConfirm}
        >
          Yes, Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrioritizeDialog; 